<script lang="ts">
  import { QueryClientProvider } from "@tanstack/svelte-query";
  import { queryClient } from "./api/query";
  import { Router } from "./router";
  import { routes } from "./routes";

  // App root. Three responsibilities only:
  //   1. Provide the TanStack QueryClient to the tree.
  //   2. Mount the Router with the route table.
  //   3. Anything else (auth bootstrap, theme switching, etc.) lives
  //      in src/state/* or in individual views.
  //
  // Views land in src/views/. Add a new entry to src/routes.ts and the
  // Router picks it up.
</script>

<QueryClientProvider client={queryClient}>
  <Router {routes} />
</QueryClientProvider>
